import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { patternFilterSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { SecretsManagerService } from '../../service';

export type PeriodicRotationConfig = typeof PeriodicRotationConfig._.Config;

export const PeriodicRotationConfig = IntegrationConfig.make({
  service: SecretsManagerService,
  name: Integration_Handler_Names_Enum.PeriodicRotation,
  configSchema: z.object({
    maxDaysSinceRotation: z.number().min(1).max(180),
    secretPatternFilter: patternFilterSchema.optional(),
  }),
});
